import React from 'react';
import { useWishlist } from './WishlistContext';

/**
 * Save-to-wishlist control for product cards and PDP.
 */
export default function WishlistHeartButton({
  product,
  categorySlug,
  className = '',
  size = 'md',
  showLabel = false,
}) {
  const { isWishlisted, toggle, busy } = useWishlist();
  const cat = String(categorySlug || '');
  const id = String(product?.id || '');
  if (!id || !cat) return null;

  const saved = isWishlisted(cat, id);
  const sizeClass = size === 'sm' ? 'wishlist-heart-btn--sm' : 'wishlist-heart-btn--md';

  return (
    <button
      type="button"
      className={`wishlist-heart-btn ${sizeClass}${saved ? ' is-saved' : ''} ${className}`.trim()}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        void toggle(product, cat);
      }}
      disabled={busy}
      aria-pressed={saved}
      aria-label={saved ? 'Remove from saved items' : 'Save to wishlist'}
      title={saved ? 'Saved' : 'Save for later'}
    >
      <svg className="wishlist-heart-btn__icon" viewBox="0 0 24 24" aria-hidden>
        {saved ? (
          <path
            d="M12 20.5l-1.1-1C5.5 14.2 2 11.1 2 7.25 2 4.5 4.2 2.5 6.9 2.5c1.6 0 3.1.8 4.1 2.1C12 3.3 13.4 2.5 15 2.5 17.7 2.5 20 4.5 20 7.25c0 3.85-3.5 6.95-8.9 12.25L12 20.5z"
            fill="currentColor"
          />
        ) : (
          <path
            d="M12 20.5l-1.1-1C5.5 14.2 2 11.1 2 7.25 2 4.5 4.2 2.5 6.9 2.5c1.6 0 3.1.8 4.1 2.1C12 3.3 13.4 2.5 15 2.5 17.7 2.5 20 4.5 20 7.25c0 3.85-3.5 6.95-8.9 12.25L12 20.5z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
        )}
      </svg>
      {showLabel ? <span className="wishlist-heart-btn__label">{saved ? 'Saved' : 'Save'}</span> : null}
    </button>
  );
}
